import Vue from 'vue';

async function insertScript(src, id, parentElement) {
  return new Promise((resolve, reject) => {
    const script = window.document.createElement('script');
    script.async = true;
    script.src = src;
    script.id = id;
    parentElement.appendChild(script);
    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);
  });
} // noinspection TypeScriptExplicitMemberType


let lastWidgetInstance = null;

function reset(config) {
  if (lastWidgetInstance) {
    lastWidgetInstance.update(config);
  }
} // let fcInstance = null;


var script = Vue.extend({
  name: 'FastcommentsVue',
  // vue component name
  props: {
    config: {
      type: Object
    }
  },

  data() {
    return {
      widgetId: `fastcomments-widget-${Math.random()}-${Date.now()}`
    };
  },

  async mounted() {
    // @ts-ignore
    if (window && !window.FastCommentsUI) {
      const src = this.config.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/embed-v2.min.js' : 'https://cdn.fastcomments.com/js/embed-v2.min.js';
      await insertScript(src, 'fastcomments-widget-script', window.document.body);
    } // @ts-ignore


    lastWidgetInstance = window.FastCommentsUI(document.getElementById(this.widgetId), this.config);
  },

  watch: {
    config(newConfig) {
      reset(newConfig);
    }

  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "fastcomments-vue"
  }, [_c('div', {
    attrs: {
      "id": _vm.widgetId
    }
  })]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

async function insertScript$1(src, id, parentElement) {
  return new Promise((resolve, reject) => {
    const script = window.document.createElement('script');
    script.async = true;
    script.src = src;
    script.id = id;
    parentElement.appendChild(script);
    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);
  });
} // noinspection TypeScriptExplicitMemberType


let lastWidgetInstance$1 = null;

function reset$1(config) {
  if (lastWidgetInstance$1) {
    lastWidgetInstance$1.update(config);
  }
} // let fcInstance = null;


var script$1 = Vue.extend({
  name: 'FastCommentsCollabChat',
  // vue component name
  props: {
    config: {
      type: Object
    },
    targetRef: {
      default: null
    }
  },

  data() {
    return {
      widgetId: `fastcomments-collab-chat-${Math.random()}-${Date.now()}`
    };
  },

  async mounted() {
    // @ts-ignore
    if (window && !window.FastCommentsCollabChat) {
      const src = this.config.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/embed-collab-chat.min.js' : 'https://cdn.fastcomments.com/js/embed-collab-chat.min.js';
      await insertScript$1(src, 'fastcomments-collab-chat-script', window.document.body);
    } // @ts-ignore


    lastWidgetInstance$1 = window.FastCommentsCollabChat(this.targetRef, this.config);
  },

  watch: {
    config(newConfig) {
      reset$1(newConfig);
    }

  }
});

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "fastcomments-collab-chat"
  }, [_c('div', {
    attrs: {
      "id": _vm.widgetId
    }
  })]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

async function insertScript$2(src, id, parentElement) {
  return new Promise((resolve, reject) => {
    const script = window.document.createElement('script');
    script.async = true;
    script.src = src;
    script.id = id;
    parentElement.appendChild(script);
    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);
  });
} // noinspection TypeScriptExplicitMemberType


let lastWidgetInstance$2 = null;

function reset$2(config) {
  if (lastWidgetInstance$2) {
    lastWidgetInstance$2.update(config);
  }
} // let fcInstance = null;


var script$2 = Vue.extend({
  name: 'FastCommentsImageChat',
  // vue component name
  props: {
    config: {
      type: Object
    },
    targetRef: {
      default: null
    }
  },

  data() {
    return {
      widgetId: `fastcomments-image-chat-${Math.random()}-${Date.now()}`
    };
  },

  async mounted() {
    // @ts-ignore
    if (window && !window.FastCommentsImageChat) {
      const src = this.config.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/embed-image-chat.min.js' : 'https://cdn.fastcomments.com/js/embed-image-chat.min.js';
      await insertScript$2(src, 'fastcomments-image-chat-script', window.document.body);
    } // @ts-ignore


    lastWidgetInstance$2 = window.FastCommentsImageChat(this.targetRef, this.config);
  },

  watch: {
    config(newConfig) {
      reset$2(newConfig);
    }

  }
});

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "fastcomments-image-chat"
  }, [_c('div', {
    attrs: {
      "id": _vm.widgetId
    }
  })]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

async function insertScript$3(src, id, parentElement) {
  return new Promise((resolve, reject) => {
    const script = window.document.createElement('script');
    script.async = true;
    script.src = src;
    script.id = id;
    parentElement.appendChild(script);
    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);
  });
} // noinspection TypeScriptExplicitMemberType


let lastWidgetInstance$3 = null;

function reset$3(config) {
  if (lastWidgetInstance$3) {
    lastWidgetInstance$3.update(config);
  }
} // let fcInstance = null;


var script$3 = Vue.extend({
  name: 'FastCommentsLiveChat',
  // vue component name
  props: {
    config: {
      type: Object
    }
  },

  data() {
    return {
      widgetId: `fastcomments-live-chat-${Math.random()}-${Date.now()}`
    };
  },

  async mounted() {
    // @ts-ignore
    if (window && !window.FastCommentsLiveChat) {
      const src = this.config.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/embed-live-chat.min.js' : 'https://cdn.fastcomments.com/js/embed-live-chat.min.js';
      await insertScript$3(src, 'fastcomments-live-chat-script', window.document.body);
    } // @ts-ignore


    lastWidgetInstance$3 = window.FastCommentsLiveChat(document.getElementById(this.widgetId), this.config);
  },

  watch: {
    config(newConfig) {
      reset$3(newConfig);
    }

  }
});

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "fastcomments-live-chat"
  }, [_c('div', {
    attrs: {
      "id": _vm.widgetId
    }
  })]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

// Import vue components
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// install function executed by Vue.use()
const install = function installFastcommentsVue(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('FastComments', __vue_component__);
  Vue.component('FastCommentsCollabChat', __vue_component__$1);
  Vue.component('FastCommentsImageChat', __vue_component__$2);
  Vue.component('FastCommentsLiveChat', __vue_component__$3);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()
// eslint-disable-next-line @typescript-eslint/no-explicit-any


__vue_component__.install = install; // eslint-disable-next-line @typescript-eslint/no-explicit-any

__vue_component__$1.install = install; // eslint-disable-next-line @typescript-eslint/no-explicit-any

__vue_component__$2.install = install; // eslint-disable-next-line @typescript-eslint/no-explicit-any

__vue_component__$3.install = install; // Export components

const FastComments = __vue_component__;
const FastCommentsCollabChat = __vue_component__$1;
const FastCommentsImageChat = __vue_component__$2;
const FastCommentsLiveChat = __vue_component__$3; // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
export { FastComments, FastCommentsCollabChat, FastCommentsImageChat, FastCommentsLiveChat };
